import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import FullScreenOverlay from "./FullScreenOverlay";

import { loadFeedbacks } from "../../redux/actions/careplanActions";
import { formatDate, formatTime } from "../../utils/dateUtils";

const FeedbackOverlay = ({ publicId, nhsNumber, onClose }) => {
  const dispatch = useDispatch();
  const { feedbackList = [], feedbackLoading } = useSelector((s) => s.careplan);

  useEffect(() => {
    dispatch(loadFeedbacks(publicId));
  }, [dispatch, publicId]);

  // group by YYYY-MM-DD
  const groups = feedbackList.reduce((acc, fb) => {
    const day = formatDate(fb.created_at);
    acc[day] = acc[day] || [];
    acc[day].push(fb);
    return acc;
  }, {});

  const todayKey = formatDate(new Date());

  return (
    <FullScreenOverlay
      title="Feedback"
      subtitle={
        <span className="body-text-regular">Care Plan: {nhsNumber}</span>
      }
      iconClose
      onClose={onClose}
      width="528px"
      height="75vh"
      isSlimModal={false}
    >
      {feedbackLoading && <p>Loading...</p>}

      {!feedbackLoading &&
        Object.entries(groups).map(([day, items]) => (
          <div key={day}>
            <DateDivider>
              {day === todayKey ? `Today, ${day}` : day}
            </DateDivider>

            {items.map(({ id, name, email, comment, created_at }) => (
              <Entry key={id}>
                <Header>
                  <Name>{name}</Name>
                  <Time>{formatTime(created_at)}</Time>
                </Header>
                <Email>{email}</Email>
                <Comment>{comment}</Comment>
              </Entry>
            ))}
          </div>
        ))}
    </FullScreenOverlay>
  );
};

export default FeedbackOverlay;

// — styled components —
const DateDivider = styled.div`
  display: flex;
  align-items: center;
  color: var(--Colors-Neutral-500);
  font-size: 14px;
  margin: 24px 0 8px;
  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #e0e0e0;
  }
  &::before {
    margin-right: 8px;
  }
  &::after {
    margin-left: 8px;
  }
`;

const Entry = styled.div`
  padding: 12px 0;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Name = styled.span`
  font-weight: 600;
  font-size: 16px;
`;

const Time = styled.span`
  font-size: 12px;
  color: var(--Colors-Neutral-500);
`;

const Email = styled.div`
  font-size: 14px;
  color: var(--Colors-Neutral-700);
  margin: 4px 0;
`;

const Comment = styled.p`
  margin: 8px 0 0;
  font-size: 15px;
  line-height: 1.4;
`;
